module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAABNUlEQVR4AWOgC1DxWgpHCu6LgUjWdRGQlHNdrOC2WMlzCVwWRYOy11KgCruEDY5JGzOaDnplbk2o3ueQuFE/eCVQG7oGRY8lRmGrqyaezGo5FF6yyyt7u1n0ZveMbblth8OKd1ZPPAky0ROmAcLR8F0ONF7BfYmE03KXyAm1FWWqnvMlnYDiy+ziN2B3kqL7Yhm3FdKuK3ubCh9vcF82IUXdZzGQq+CO6iSEjz2Wx2V2LJuQemm5PxDdWu09vSPHNmKGsucy7Bpk3FbGZ3Y8XO9xeYXfhWUBQARkT2zJB4pj16AMtqStrhRo/M3VPrfXeB2eH+YQOV3OfQV2DWDfL5NwWT2/J2Nhb3pBUYNH7GR59+VY4wGBZN1WpOS0WobOFndereCBUI2pAYGUPJcBEaY4w6AEAGrCuuhWQapYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/_kosovo.png
// module id = 1314
// module chunks = 0